import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("span", null, "It seems that you have unsaved changes. Do you want to leave this page without saving them?", -1)
const _hoisted_2 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "Leave page?",
    modelValue: _ctx.state.dialogVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.dialogVisible = $event)),
    width: "45%",
    top: "30vh"
  }, {
    footer: _withCtx(() => [
      _createVNode("span", _hoisted_2, [
        _createVNode("button", {
          class: "button secondary",
          style: {"margin-right":"16px"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.dialogVisible = false))
        }, " No "),
        _createVNode("button", {
          class: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.leave()))
        }, " Yes ")
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["modelValue"]))
}